import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface CollectionHistoricalPositionResponseModel {
	readonly date: string;
	readonly cashPosition: number | null;
	readonly invested: number | null;
	readonly gain: number | null;
	readonly profit: number | null;
	readonly marketValue: number;
}

export const useCollectionHistoricalPositions = (collectionId: string, days: number) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["collectionHistoricalPositions", collectionId, days],
		queryFn: () => http<CollectionHistoricalPositionResponseModel[]>({
			method: "GET",
			url: `/collection/${collectionId}/historical-positions?days=${days}`
		}),
		placeholderData: x => x
	});
};
